/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Circle = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16" width={props.size || "16px"} height={props.size || "16px"} fill="none">
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#40414B" />
    </BaseSvgIcon>
  )
}

export default Circle
